import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { tv } from "tailwind-variants";
import cn from "../../../utils/cn";
const tableRow = tv({
    base: "border-y border-gray-2 first:border-none",
    variants: {
        align: {
            left: "text-left",
            center: "text-center",
            right: "text-right",
        },
        condensed: {
            true: "p-1.5",
            false: "p-2.5",
        },
        isEven: {
            true: "bg-gray-1",
            false: "bg-white",
        },
        hover: {
            true: "hover:border-y hover:border-gray-4 hover:bg-primary-2",
            false: "hover:bg-transparent",
        },
    },
    defaultVariants: {
        align: "left",
        hover: true,
        condensed: false,
    },
});
const TableRow = ({ className, align, condensed, hover, isEven, ...props }) => {
    return (_jsx("tr", { className: cn(tableRow({ align, condensed, isEven, hover }), "data-[state=selected]:border-gray-4 data-[state=selected]:border-y data-[state=selected]:bg-gray-2", className), ...props }));
};
TableRow.displayName = "TableRow";
export default memo(TableRow);
